import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import AccountServiceModel from '@/models/AccountServiceModel';

@model.urnResource('email_change_request')
@doc.path('/email_change_requests/validate')
export default class EmailChangeValidateModel extends AccountServiceModel {
	@doc.string declare token: string;
	@doc.string declare newEmail: string;
}
